module.exports = __webpack_public_path__ + "img/945D43_E5AAA0_351F14_CC8B78-256px.94f68c59.png";